import openPopup from '../popup.js';

const imgThumbs = document.querySelectorAll('.demo-wrap .img')
let imgLargeSrc = document.querySelector('.preview-wrap img')

imgThumbs.forEach(item => {
   item.onclick = () => {
      imgLargeSrc.setAttribute('src', item.dataset.img)
   }
})

new openPopup({
   selector: '#popup-preview',
   elOpen: '.demo-wrap .img',
   elClose: '#popup-preview .ui-close',
   overlay: '#popup-preview .popup-overlay',
})